const COLORS = {
	errors: '#DC2626',
	redirects: '#D97706',
	indexable: '#16A34A',
	noindex: '#9ca3af',
};

const fmt = (n) => Number(n || 0).toLocaleString('vi-VN');

/**
 * Biểu đồ cột SVG thuần cho 1 nhóm chỉ số theo các lần crawl (≤10 điểm).
 * series: [{date, crawl_id, ...}], keys: [{key, label}] — cột nhóm cạnh nhau,
 * tooltip native qua <title>.
 */
function BarChart({title, series, keys}) {

	const W = 360;
	const H = 170;
	const P = {top: 12, right: 8, bottom: 22, left: 8};
	const innerW = W - P.left - P.right;
	const innerH = H - P.top - P.bottom;

	const max = Math.max(1, ...series.flatMap((d) => keys.map((k) => d[k.key] || 0)));

	const n = series.length;
	const slot = innerW / n;                          // bề rộng 1 lần crawl
	const barW = Math.min(18, (slot * 0.7) / keys.length);

	return (
		<div style={{flex: '1 1 300px', minWidth: 260}}>
			<div style={{fontSize: 13, fontWeight: 600, marginBottom: 4}}>{title}</div>
			<div style={{display: 'flex', gap: 12, flexWrap: 'wrap', fontSize: 12, color: '#6b7280', marginBottom: 4}}>
				{keys.map((k) => (
					<span key={k.key} style={{display: 'inline-flex', alignItems: 'center', gap: 5}}>
						<span style={{width: 9, height: 9, borderRadius: 2, background: COLORS[k.key], display: 'inline-block'}} />
						{k.label}
					</span>
				))}
			</div>
			<svg viewBox={`0 0 ${W} ${H}`} style={{width: '100%', height: 'auto', display: 'block'}}>
				{/* Lưới ngang */}
				{[0, 0.5, 1].map((g) => (
					<line key={g} x1={P.left} y1={P.top + innerH * (1 - g)} x2={W - P.right} y2={P.top + innerH * (1 - g)}
						stroke="#eef0f4" strokeWidth="1" />
				))}

				{series.map((d, i) => {
					const groupW = keys.length * barW;
					const x0 = P.left + slot * i + (slot - groupW) / 2;

					return (
						<g key={d.crawl_id || i}>
							{keys.map((k, j) => {
								const v = d[k.key] || 0;
								const h = (innerH * v) / max;

								return (
									<rect key={k.key}
										x={x0 + j * barW} y={P.top + innerH - h}
										width={Math.max(2, barW - 2)} height={Math.max(v > 0 ? 2 : 0, h)}
										rx="2" fill={COLORS[k.key]}>
										<title>{`${d.date} — ${k.label}: ${fmt(v)}`}</title>
									</rect>
								);
							})}
							<text x={P.left + slot * i + slot / 2} y={H - 6} fontSize="9.5" fill="#9ca3af" textAnchor="middle">
								{String(d.date).slice(5)}
							</text>
						</g>
					);
				})}
			</svg>
		</div>
	);
}

/**
 * Xu hướng chất lượng crawl theo thời gian (#1 Dashboard): 2 biểu đồ cột cạnh nhau —
 * "Lỗi & Chuyển hướng" (URL 4xx/5xx + 3xx) và "Trạng thái index" (cho index / noindex)
 * qua tối đa 10 lần crawl 'done' gần nhất. Dữ liệu: crawl.history của api projects/{id}/dashboard.
 */
function CrawlTrendChart({history = []}) {

	if (history.length < 2) return null;

	return (
		<div style={{display: 'flex', gap: 24, flexWrap: 'wrap', marginTop: 16}}>
			<BarChart
				title="Lỗi & Chuyển hướng theo lần crawl"
				series={history}
				keys={[{key: 'errors', label: 'URL lỗi (4xx/5xx)'}, {key: 'redirects', label: 'Redirect (3xx)'}]}
			/>
			<BarChart
				title="Trạng thái index theo lần crawl"
				series={history}
				keys={[{key: 'indexable', label: 'Cho index'}, {key: 'noindex', label: 'Noindex'}]}
			/>
		</div>
	);
}

export default CrawlTrendChart;
